'use client'

import { ChevronRight, Star } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import { Button } from '@/components/ui/button'
import wavyLineImg from '@/public/img/wavy-line.svg'

export default function Hero() {
  return (
    <div className="flex flex-col items-center gap-8 px-4 lg:flex-row lg:flex-wrap lg:items-center lg:justify-between lg:gap-0 lg:px-0">
      {/* Text — exibido primeiro no mobile */}
      <div className="w-full text-center lg:order-2 lg:mx-auto lg:max-w-180 lg:text-left xl:mx-0 xl:max-w-122.25">
        <div className="mx-auto max-w-120 space-y-2 lg:mx-0">
          <h1 className="font-bold text-3xl text-neutral-900 leading-tight lg:text-5.5xl lg:leading-none">
            Encontre os melhores Cursos Online na Área da Saúde
          </h1>
          <Image
            alt=""
            className="mx-auto opacity-50 lg:mx-0"
            src={wavyLineImg}
            unoptimized
          />
        </div>

        <div className="mt-6 flex flex-col items-center gap-3 lg:mt-4 lg:max-w-80 lg:flex-row lg:items-center lg:justify-start lg:gap-4">
          <Button asChild className="min-h-10 lg:max-w-53" size="lg">
            <Link className="font-semibold text-sm" href="/conta/novo">
              Comece Grátis
            </Link>
          </Button>

          {/* Pós-Graduação — exibido somente no mobile (no desktop o acesso
              fica no menu superior). Replica a organização do soeducador. */}
          <Button
            asChild
            className="w-full lg:hidden"
            size="lg"
            variant="outline"
          >
            <Link
              className="font-semibold text-sm"
              href="/cursos/pos-graduacoes"
            >
              Pós-Graduação
            </Link>
          </Button>

          <Button
            asChild
            className="w-full lg:w-1/2"
            id="courses-button"
            size="lg"
          >
            <Link
              className="flex items-center justify-center gap-2 font-bold"
              href="/cursos"
            >
              Ver cursos online
              <ChevronRight />
            </Link>
          </Button>
        </div>
      </div>

      {/* Imagem — exibida abaixo do texto no mobile */}
      <div className="relative mx-auto w-full max-w-xs lg:order-1 lg:mx-0 lg:mt-0 lg:w-auto lg:max-w-none">
        <Image
          alt="Mulher profissional de saúde sorrindo"
          className="mx-auto w-full lg:max-w-122"
          height={546}
          priority={true}
          quality={65}
          src="/img/hero-estetus.webp"
          width={588}
        />

        <Image
          alt="Selo MEC"
          className="-right-2 lg:-right-24 absolute top-4 w-20 lg:top-auto lg:bottom-20 lg:w-40"
          height={50}
          src="/img/selo-mec.webp"
          width={50}
        />

        <div className="lg:-bottom-10 lg:-translate-x-1/2 mt-3 flex items-center gap-2 rounded-xl bg-white px-4 py-3 shadow-md lg:absolute lg:left-1/2 lg:mt-0 lg:w-[90%] lg:max-w-md">
          <Star className="h-5 w-5 shrink-0 text-indigo-600" />

          <p className="font-medium text-gray-800 leading-snug">
            Certificados emitidos por <br />
            instituição credenciada ao MEC
          </p>
        </div>
      </div>
    </div>
  )
}
